import React from 'react';

import PropTypes from 'prop-types';
import { faAngleRight } from '@awesome.me/kit-a6e51d954f/icons/classic/regular';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { DropdownMenuTrigger as ShadcnDropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { SidebarMenuButton } from '@/components/ui/sidebar';
import { iconShape } from '../../../../../../../../../shared/types';
import { SIDEBAR_MENU_BUTTON_CLASSES } from '../../../../constants';
import WorkspaceDetails from './WorkspaceDetails';
import WorkspaceLogo from './WorkspaceLogo';

const DropdownMenuTrigger = ({ activeWorkspace }) => {
  const { logo, name, phone } = activeWorkspace;

  return (
    <ShadcnDropdownMenuTrigger asChild>
      <SidebarMenuButton className={SIDEBAR_MENU_BUTTON_CLASSES} size="lg">
        <WorkspaceLogo logo={logo} />
        <WorkspaceDetails name={name} phone={phone} />
        <FontAwesomeIcon icon={faAngleRight} />
      </SidebarMenuButton>
    </ShadcnDropdownMenuTrigger>
  );
};

DropdownMenuTrigger.propTypes = {
  activeWorkspace: PropTypes.shape({
    logo: iconShape.isRequired,
    name: PropTypes.string.isRequired,
    phone: PropTypes.string.isRequired,
  }).isRequired,
};

export default DropdownMenuTrigger;
